import { useMemo } from 'react';
import { CustomModal } from '../CustomModal';
import { Badge, Btn, DataTable } from '../ui';
import type { DataTableColumn } from '../ui';
import type { ConfirmationRow } from './dailyBriefingData';

interface ConfirmationsModalProps {
    visible: boolean;
    rows: ConfirmationRow[];
    confirmedCount: number;
    crewCount: number;
    topicTitle: string | null;
    onDismiss: () => void;
}

export function ConfirmationsModal({
    visible,
    rows,
    confirmedCount,
    crewCount,
    topicTitle,
    onDismiss,
}: ConfirmationsModalProps) {
    const columns = useMemo<DataTableColumn<ConfirmationRow>[]>(
        () => [
            {
                id: 'name',
                header: 'Crew member',
                mobileCardPrimary: true,
                renderCell: (row) => row.name,
                sortable: true,
                sortValue: (row) => row.name,
            },
            {
                id: 'status',
                header: 'Status',
                renderCell: (row) => (
                    <Badge
                        badgeText={row.confirmed ? 'Confirmed' : 'Pending'}
                        badgeClasses={row.confirmed ? 'db-status-badge db-status-badge--ok' : 'db-status-badge'}
                    />
                ),
            },
        ],
        [],
    );

    return (
        <CustomModal
            visible={visible}
            onDismiss={onDismiss}
            header="View Confirmations"
            size="large"
            footer={<Btn variant="secondary" buttonText="Close" buttonOnClick={onDismiss} />}
        >
            <p className="db-confirmations-summary">
                {confirmedCount} / {crewCount} crew confirmed today
                {topicTitle ? ` for “${topicTitle}”` : ''}.
            </p>
            <DataTable
                columns={columns}
                rows={rows}
                getRowKey={(row) => row.userId}
                emptyState={<div className="db-empty-state">No crew members found for this company.</div>}
                mobileCardLayout
            />
        </CustomModal>
    );
}
